const paypal = {
  staging: 'AWCF-qjemyMHZYylfvZR1kOkzpHIjvp3VLEMLyZ2xTOmLSBn4zUeN2XAqtGo1mqV1pCTrLPwJN97N67w',
  production: 'AdihF1YU4BM59wVOe868kuVPJYn8qwXRS3S2g-DGnXggXE1DAqwIaIRVIA6PsZmEsTyTvV5cNqLygTsd',
};

export default paypal;
